import { render, staticRenderFns } from "./SelectAccommodation.vue?vue&type=template&id=4308df8c"
import script from "./SelectAccommodation.vue?vue&type=script&lang=js"
export * from "./SelectAccommodation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports